import { PAGE_KEYS, PREFERENCE_KEYS } from 'lib/constants';
import * as HttpService from './http.service';
import * as URL from './url.service';

export const createUserPreference = (data) => HttpService.postWithAuth(URL.USER_PREFERENCE(), data);
export const getUserPreference = () => HttpService.getWithAuth(URL.USER_PREFERENCE());

// Fetched fresh from the API rather than read from the cached DataContext userPreferences —
// OMON opens in its own popup window, so a pair switched there never updates the main window's
// cached preferences. Hitting the API directly is the only way to see that update immediately.
export const getLastOmonCurrency = async () => {
    const response = await getUserPreference();
    return response?.data?.entity?.find(
        (pref) => pref.page_key === PAGE_KEYS.OMON && pref.preference_key === PREFERENCE_KEYS.LAST_CURRENCY
    )?.preference_value ?? null;
};
